import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

import type SourceRecord from 'webapp/models/source';

interface Args {
	model: SourceRecord;
	onChoose: (sourceId: string) => void;
}

export default class CommonResolutioncenterItemSourceChoiceComponent extends Component<Args> {
	@service('model-manager/sources') declare mmSourcesService: Service.ModelManager.Sources;

	get source() {
		return this.mmSourcesService.createModelFromRecord(this.args.model);
	}

	@action
	choose() {
		this.args.onChoose(this.source.id!);
	}
	<template>
		<li>
			<a role="button" {{on "click" this.choose}}>{{this.source.title}}</a>
			<small>by {{this.source.createdByText}}&nbsp;{{this.source.createdRelative}}</small>
		</li>
	</template>
}
